
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aL23w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $113a14f6b780efe1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $fAZgY = parcelRequire("fAZgY");

var $kGR8U = parcelRequire("kGR8U");

var $7jTnu = parcelRequire("7jTnu");

var $31y1Z = parcelRequire("31y1Z");

const $113a14f6b780efe1$var$AfterPaintIssuePreEval = ()=>{
    const route = (0, $hih5V.useCurrentRoute)();
    (0, $fAZgY.useEffectWithCondition)(()=>{
        if ((0, $31y1Z.PREEVAL_ROUTES).has(route.name) && (!(0, $7jTnu.fg)('spike_removing_lazyissueapp_from_nin_routes') || !(0, $31y1Z.EXCLUDE_PREEVAL_ROUTES).has(route.name)) && (!(0, $7jTnu.fg)('jsw-disable-issue-app-full-page-load') || !(0, $31y1Z.EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES).has(route.name))) {
            (()=>{
                (0, $kGR8U.markAsBentoBundleReady)((parcelRequire("7UhFY")));
            })();
            performance.mark((0, $31y1Z.AFTER_PAINT_ISSUE_PREEVAL_MARK));
        }
    }, [
        route.name
    ], ()=>(0, $7jTnu.fg)('jfp_magma_shared-component-perf-1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};
var $113a14f6b780efe1$export$2e2bcd8739ae039 = $113a14f6b780efe1$var$AfterPaintIssuePreEval;

});
parcelRegister("kGR8U", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $393e398983932379$export$d9ff0b3329728986);

var $cJAh3 = parcelRequire("cJAh3");

var $dydef = parcelRequire("dydef");
let $393e398983932379$var$reportedBentoBundleReady = false;
const $393e398983932379$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($393e398983932379$var$reportedBentoBundleReady) return;
        $393e398983932379$var$reportedBentoBundleReady = true;
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("31y1Z", function(module, exports) {

$parcel$export(module.exports, "PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$8411da1302b7546c);
$parcel$export(module.exports, "EXCLUDE_PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$bd0ce8e012b9a3e4);
$parcel$export(module.exports, "EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES", () => $54ce935e6d4d4d0c$export$53724bb7236bede3);
$parcel$export(module.exports, "AFTER_PAINT_ISSUE_PREEVAL_MARK", () => $54ce935e6d4d4d0c$export$76f8f9afcfc4a896);
const $54ce935e6d4d4d0c$export$8411da1302b7546c = new Set([
    'archived-projects-directory',
    'archived-project-direct-link',
    'boards-directory',
    'classic-business-board',
    'classic-business-board-embed',
    'classic-business-board-custom-embed',
    'classic-business-calendar',
    'classic-business-calendar-embed',
    'classic-business-form',
    'classic-business-form-submit',
    'classic-business-list',
    'classic-business-list-embed',
    'classic-business-timeline',
    'classic-business-timeline-embed',
    'connect-general',
    'connect-general-invalid',
    'connect-general-service-desk-project',
    'connect-project',
    'dashboards-directory',
    'dashboards-directory-secure',
    'filters-directory',
    'forge-spa-admin',
    'global-issue-navigator',
    'global-settings-issues-custom-fields-view',
    'global-settings-issues-fieldlayouts-view',
    'global-settings-issues-fieldlayouts-schemes-view',
    'global-settings-issues-linktypes-view',
    'global-settings-issues-notification-view',
    'global-settings-issues-permissions-schemes-view',
    'global-settings-issues-priorities',
    'global-settings-issues-resolutions',
    'global-settings-issues-security-schemes',
    'global-settings-issues-statuses',
    'global-settings-issues-field-schemes-view',
    'global-settings-issues-field-screens',
    'global-settings-issues-subtasks-manage',
    'global-settings-issues-time-tracking',
    'global-settings-issues-types-view',
    'global-settings-issues-types-schemes-manage',
    'global-settings-issues-types-screen-schemes-view',
    'global-settings-issues-workflows-pages',
    'global-settings-issues-workflows-schemes-view',
    'issue-embed',
    'knowledge-hub-all-articles',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'knowledge-hub-suggested-topics',
    'opsgenie-schedule',
    'people-index',
    'personal-settings',
    'polaris-ideas',
    'products-jsw-configuration',
    'projects-directory',
    'project-components',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'project-pages',
    'project-settings-components',
    'project-settings-versions',
    'project-versions',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-board-embed',
    'rapidboard-report',
    'rapidboard-user-backlog',
    'rapidboard-user-board',
    'rapidboard-user-report',
    'servicedesk-change-calendar',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-connect-project',
    'servicedesk-create-project',
    'servicedesk-customers-v2',
    'servicedesk-boards',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organization_v2',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-edit',
    'servicedesk-queues-issue',
    'servicedesk-queues-landing',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'servicedesk-sla-settings',
    'global-settings-issues-cmdb-field-config',
    'admin-oauth-credentials',
    'software-backlog',
    'software-boards',
    'software-code',
    'software-code-classic',
    'software-security',
    'software-security-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-issue-navigator',
    'software-release-notes',
    'software-reports',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-velocity',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline',
    'software-timeline-classic',
    'system-dashboard-edit',
    'trash-projects-directory',
    'your-work'
]);
const $54ce935e6d4d4d0c$export$bd0ce8e012b9a3e4 = new Set([
    'global-issue-navigator',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'servicedesk-issues',
    'software-issue-navigator',
    'software-timeline',
    'software-timeline-classic'
]);
const $54ce935e6d4d4d0c$export$53724bb7236bede3 = new Set([
    'software-backlog',
    'software-boards',
    'rapidboard-backlog',
    'rapidboard-board'
]);
const $54ce935e6d4d4d0c$export$76f8f9afcfc4a896 = 'AfterPaintIssuePreEval:rendered';

});

parcelRegister("7UhFY", function(module, exports) {

let $5c1b797442590360$var$load = (parcelRequire("gLHA4"))(4);




























module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            $5c1b797442590360$var$load("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $5c1b797442590360$var$load("dWro6")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("c4kut")
        ]);
    }),
    (parcelRequire("g81qY"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $5c1b797442590360$var$load("g9Y8c")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("5x9Yt")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $5c1b797442590360$var$load("lw2Bw")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("2lCLc")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("6u1ax"),
                    $5c1b797442590360$var$load("kNFvF"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a"),
                    $5c1b797442590360$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("enrdU")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("w71gM"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("2EwqZ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("2Bh8z"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("5ERkJ")
                ]);
            }),
            $5c1b797442590360$var$load("fo1Iu")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("6u1ax"),
                    $5c1b797442590360$var$load("kNFvF"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a"),
                    $5c1b797442590360$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("enrdU")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("w71gM"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("2EwqZ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("2Bh8z"),
                    $5c1b797442590360$var$load("kvRbA"),
                    $5c1b797442590360$var$load("ffQaD"),
                    $5c1b797442590360$var$load("l253H"),
                    $5c1b797442590360$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("5ERkJ")
                ]);
            }),
            $5c1b797442590360$var$load("2tXQt")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $5c1b797442590360$var$load("5g4nt"),
            $5c1b797442590360$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("iQLT5")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("uxIZU")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("hzpoZ")
                ]);
            }),
            (parcelRequire("g81qY"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("5p6dC")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("aGtUJ")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("jjrrg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("jjrrg")
                ]);
            }),
            (parcelRequire("g81qY"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("iJXHy")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("dkfn8")
                ]);
            }),
            (parcelRequire("g81qY"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("iJXHy")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("dkfn8")
                ]);
            }),
            (parcelRequire("g81qY"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $5c1b797442590360$var$load("2dhUs")
                ]);
            }, function() {
                return Promise.all([
                    $5c1b797442590360$var$load("jOuGE")
                ]);
            }),
            $5c1b797442590360$var$load("d7W8O"),
            $5c1b797442590360$var$load("kvRbA"),
            $5c1b797442590360$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("7HlaD")
        ]);
    }),
    (parcelRequire("g81qY"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $5c1b797442590360$var$load("9poB6")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("i4NG1")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $5c1b797442590360$var$load("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("7BIsM")
        ]);
    }),
    (parcelRequire("g81qY"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $5c1b797442590360$var$load("jteQo")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("6Ry6c"),
            $5c1b797442590360$var$load("kvRbA"),
            $5c1b797442590360$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("g81qY"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $5c1b797442590360$var$load("8uOIl")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("eOwa8")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_aa_fg', function() {
        return Promise.all([
            $5c1b797442590360$var$load("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $5c1b797442590360$var$load("ej9s8")
        ]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("a3q1T")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $5c1b797442590360$var$load("hb7LZ")
        ]);
    }),
    $5c1b797442590360$var$load("7mIf9"),
    $5c1b797442590360$var$load("jXweD"),
    $5c1b797442590360$var$load("kNFvF"),
    $5c1b797442590360$var$load("isfJL"),
    $5c1b797442590360$var$load("b3QiB"),
    $5c1b797442590360$var$load("kVX56"),
    $5c1b797442590360$var$load("ffQaD"),
    $5c1b797442590360$var$load("kvRbA"),
    $5c1b797442590360$var$load("3yAl4"),
    $5c1b797442590360$var$load("fliVL"),
    $5c1b797442590360$var$load("76n7a"),
    $5c1b797442590360$var$load("l253H"),
    $5c1b797442590360$var$load("jbxE1"),
    $5c1b797442590360$var$load("7imUH"),
    $5c1b797442590360$var$load("j53wu")
]).then(()=>parcelRequire('5IVSD'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});




//# sourceMappingURL=AfterPaintIssuePreEval.6b9201c1.js.map
